<template>
  <div
    v-if="isMobileScreenSize"
    class="flex flex-row justify-between border items-center rounded-md w-full m-4 p-24"
  >
    <div class="flex flex-col gap-20 w-full">
      <NameSection :name="doctor.name" :gender="doctor.gender" />
      <ContactInfo
        :clinic="doctor.clinic"
        :address="doctor.address"
        :phone="doctor.phone"
      />
      <span class="text-grey-500">{{ doctor.distance }} Miles away</span>
    </div>
  </div>
  <div
    v-else
    class="flex flex-row border items-center rounded-md w-full p-24 justify-between"
  >
    <div class="flex flex-col gap-24">
      <NameSection :name="doctor.name" :gender="doctor.gender" />
      <ContactInfo
        :clinic="doctor.clinic"
        :address="doctor.address"
        :phone="doctor.phone"
      />
    </div>

    <Body class="text-right self-start"
      >({{
        $t('health_actions.scheduling.select_doctor_distance_miles', [
          doctor.distance,
        ])
      }})</Body
    >
  </div>
</template>

<script>
import NameSection from './NameSection.vue'
import ContactInfo from './ContactInfoSection.vue'
import screenSizeMixin from '~/components/mixins/screenSizeMixin'
import Body from '~/components/common/Typography/Body.vue'

export default {
  components: { NameSection, ContactInfo, Body },
  mixins: [screenSizeMixin],
  props: {
    doctor: {
      type: Object,
      required: true,
    },
  },
}
</script>
